<template>
    <oss-dialog
        v-model="model"
        title="Ajouter une ligne"
        :validDisabled="!isValid"
        :previous-display="step !== 'default'"
        @valid="valid()"
        @close="close()"
        @previous="previous()"
        prefixDataCy="InvoiceProductsDialog-valid"
        max-width="900px"
    >
        <template v-slot:activator="{ props }">
            <slot name="activator" v-bind="{ props }" />
        </template>
        <v-card :style="{ width: !$vuetify.display.smAndDown ? '40vw' : '80vw' }">
            <v-window v-model="step">
                <v-window-item value="default">
                    <v-row no-gutters class="my-2">
                        <v-col class="d-flex align-center flex-shrink-0 flex-grow-1">
                            <v-text-field-filled
                                v-model="search"
                                label="Rechercher"
                                outlined
                                hide-details
                                density="compact"
                                append-inner-icon="$search"
                                clearable
                                @click:clear="search = ''"
                            />
                        </v-col>
                        <v-col
                            class="d-flex align-center justify-end flex-shrink-1 flex-grow-0 pl-2"
                        >
                            <v-btn
                                @click="step = 'create'"
                                elevation="0"
                                color="primary"
                                size="small"
                                data-cy="InvoiceProductsDialog-add"
                            >
                                Créer <v-icon right>$add</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-list
                        style="height: 40vh; overflow: scroll"
                        v-if="!loading && companyProducts.length"
                        lines="two"
                    >
                        <template v-if="!filtredCompanyProducts.length">
                            Aucun resultat trouvé pour la recherche
                        </template>
                        <v-list-item
                            v-for="(product, i) in filtredCompanyProducts"
                            :key="i"
                            @click="selectProduct(product)"
                            :class="getProductClass(product.id)"
                            style="background: #fff"
                            :data-cy="'selectInvoiceProduct-product-' + i"
                        >
                            <v-list-item-title>
                                {{ product.title }} - {{ product.reference }}
                            </v-list-item-title>
                            <v-list-item-subtitle
                                >{{ product.unitPrice }} &#x20ac; (
                                {{ product.vatRate }} %)</v-list-item-subtitle
                            >

                            <template v-slot:append class="my-0">
                                <v-btn-icon
                                    color="secondary"
                                    :icon="
                                        product.id === selectedProduct.id
                                            ? '$radio_button_checked'
                                            : '$radio_button_unchecked'
                                    "
                                >
                                </v-btn-icon>
                            </template>
                        </v-list-item>
                    </v-list>
                    <v-row v-else-if="!loading">
                        <v-col cols="12" class="d-flex align-center justify-center">
                            Vous n'avez aucun produit enregistré
                        </v-col>
                        <v-col cols="12" class="d-flex align-center justify-center">
                            <v-btn
                                @click="startNewProduct"
                                elevation="0"
                                color="primary"
                                size="small"
                            >
                                Créer <v-icon right>$add</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12" class="text-center">
                            <v-progress-circular indeterminate color="primary" />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-divider />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="pt-3">
                        <v-col cols="6" class="d-flex align-center">
                            <template v-if="selectedProduct && selectedProduct.id">
                                <span>
                                    {{ selectedProduct.title }} - {{ selectedProduct.reference }} /
                                    {{ selectedProduct.unitPrice }} &#x20ac;
                                </span>
                                <!-- <v-radio
                                        v-if="canBeOptionnal"
                                        v-model="selectedProduct.isO"
                                        label="Optionnel"
                                        color="primary"
                                        class="d-flex justify-end px-1"
                                    ></v-radio> -->
                            </template>
                            <span class="text--secondary font-italic" v-else>
                                Sélectionnez un produit
                            </span>
                        </v-col>
                        <v-col cols="3" class="pr-1">
                            <oss-text-field-filled
                                v-model="selectedProduct.unitQuantity"
                                label="Quantité"
                                outlined
                                dense
                                hide-details
                            />
                        </v-col>
                        <v-col cols="3" class="pl-1">
                            <oss-text-field-filled
                                label="Total"
                                outlined
                                dense
                                hide-details
                                :model-value="totalAmount"
                            />
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item value="create">
                    <v-row no-gutters class="mt-2">
                        <v-col cols="8" class="pr-1">
                            <v-text-field-filled
                                v-model="newProduct.title"
                                label="Nom"
                                hide-details
                                data-cy="InvoiceProductsDialog-name"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="4" class="pl-1">
                            <v-text-field-filled
                                v-model="newProduct.reference"
                                label="Référence"
                                hide-details
                                data-cy="InvoiceProductsDialog-reference"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-2">
                        <v-col cols="6" class="pr-1">
                            <oss-text-field-filled
                                v-model="newProduct.unitPrice"
                                label="Prix unitaire"
                                outlined
                                dense
                                hide-details
                                data-cy="InvoiceProductsDialog-price"
                            />
                        </v-col>
                        <v-col cols="6" class="pl-1">
                            <v-select-filled
                                v-model="newProduct.vatRate"
                                :items="vatRates"
                                item-title="text"
                                item-value="value"
                                :menu-props="{ auto: true }"
                                label="Taux de TVA"
                                data-cy="zTillReceipt-vatRate"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-window>
        </v-card>
    </oss-dialog>
</template>

<script lang="ts">
import _ from "lodash";
import { Apollo } from "@/decorators";

import { sortBy } from "lodash";

import INVOICE_PRODUCTS from "../../graphql/invoice/InvoiceProducts.gql";
import CREATE_INVOICE_PRODUCT from "../../graphql/invoice/CreateInvoiceProduct.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

// import REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY from "../../graphql/accountableAccount/RevenueAccountableAccounts.gql"

@Component({
    emits: ["valid", "product"],
})
export class InvoiceProductsDialog extends Vue {
    @Prop({ required: true }) companyId!: string;
    @Prop() value: boolean;
    @Prop({ default: false }) canBeOptionnal: boolean; // only for quotationInvoice

    step = "default";

    search = "";

    selectedProduct = { id: "", unitQuantity: 1, unitPrice: 0 };

    model = false;

    defaultProduct = {
        title: "",
        reference: "",
        unitPrice: 0,
        vatRate: 0,
    };

    newProduct = _.cloneDeep(this.defaultProduct);

    startNewProduct() {
        this.newProduct = _.cloneDeep(this.defaultProduct);
        this.step = "create";
    }

    loading = false;

    get isValid() {
        switch (this.step) {
            case "default":
                return this.selectedProduct.id && this.selectedProduct.unitQuantity;
            case "create":
                return this.newProduct.title && this.newProduct.reference;
        }
        return false;
    }

    get totalAmount() {
        if (this.selectedProduct.id) {
            return (this.selectedProduct.unitQuantity || 0) * (this.selectedProduct.unitPrice || 0);
        }
        return 0;
    }

    get vatRates() {
        return [
            { text: "0%", value: 0 },
            { text: "2.1%", value: 2.1 },
            { text: "5.5%", value: 5.5 },
            { text: "8.5%", value: 8.5 },
            { text: "10%", value: 10 },
            { text: "20%", value: 20 },
        ];
    }

    get filtredCompanyProducts() {
        if (this.search) {
            return this.companyProducts.filter(
                (product) =>
                    product.title.toLowerCase().includes(this.search.toLowerCase()) ||
                    product.reference.toLowerCase().includes(this.search.toLowerCase()),
            );
        }
        return this.companyProducts;
    }

    previous() {
        this.step = "default";
    }

    close() {
        this.model = false;
        this.previous();
        this.selectedProduct = { id: "", unitQuantity: 1, unitPrice: 0 };
    }

    @Apollo({
        query: INVOICE_PRODUCTS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                if (data?.invoiceProducts?.length) {
                    for (const iP of data.invoiceProducts) {
                        // if(!iP.isOptional) {
                        //     iP.isOptional = false
                        // }
                    }
                    this.companyProducts = sortBy(data.invoiceProducts, ["name", "reference"]);
                }
            }
        },
    })
    companyProducts = [];

    async valid() {
        switch (this.step) {
            case "default":
                debugger;
                this.$emit("valid", this.selectedProduct);
                this.close();
                break;
            case "create":
                this.selectedProduct = await this.createProduct();
                this.step = "default";
                break;
        }
    }

    getProductClass(productId) {
        let productClass = "mt-2 oss-list-item border-sm rounded-xl";
        if (
            this.selectedProduct &&
            this.selectedProduct.id &&
            productId === this.selectedProduct.id
        ) {
            productClass += " oss-list-item-selected";
        }
        return productClass;
    }

    selectProduct(product) {
        this.selectedProduct = { ...this.selectedProduct, ...product };
        this.$emit("product", product);
    }

    async createProduct() {
        debugger;
        const newProduct = { ...this.newProduct, company: { connect: { id: this.companyId } } };

        // console.log("newProduct", newProduct)

        const product = await this.$apollo.mutate({
            mutation: CREATE_INVOICE_PRODUCT,
            variables: {
                product: newProduct,
            },
        });

        const registeredProduct = { ...this.newProduct, id: product.data.createInvoiceProduct.id };
        this.companyProducts = sortBy(
            [...this.companyProducts, registeredProduct],
            ["name", "reference"],
        );

        this.newProduct = _.cloneDeep(this.defaultProduct);

        return { ...this.selectedProduct, ...registeredProduct };
    }
}

export default toNative(InvoiceProductsDialog);
</script>
